import React, { useContext, useEffect, useState } from 'react'
// import './fileUpload.css'
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Close';
import IconsColor from '../../utility/iconsColor';
import styles from "../../../assets/styles/componentStyles/utility/fileUpload.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import { Button, IconButton, Tooltip } from '@mui/material';
import GlobalButton from '../globalButton/button';
import { FileUploadOutlined } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import { blackColor, primaryColor, redColor, whiteColor } from '../../../utils/colors';
import { getVendorField } from '../../../utils/whiteLabelling';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { getMediaUrl } from '../../../pages/ruleBasedInbox/utils';
// import "../../../../assets/styles/parentFormwizStyles.css"
var FormData = require('form-data');

interface fileUploadInterface {
    uploadedFileDetails: any,
    multipleFileAllow: boolean,
    fileSizeAllowed?: number,
    fileTypeAllowed: string,
    fileNumberAllowed: number,
    uploadFileHandler: (event: any) => void,
    removeFileHandler: (data: any) => void,
    isDisabled: boolean | string,
    isDeleteFileIconVisible?: boolean,
    bgColor?: string,
    flagShowJustIconBgColor?: string,
    flagShowJustIcon?: boolean,
    flagWhatsapp?: boolean,
    flagLocallyStoreFile?: boolean // When you pass this flag true, Please don't forgot to send blobUrl in the uploadedFileDetailes. 
    flagRemoveFileConfirmationPopup?: boolean // Pass true, if you don't want to show confirmation popup on file removal.
}

const FileUpload = (props: fileUploadInterface) => {
    const { uploadedFileDetails,
        multipleFileAllow,
        fileSizeAllowed,
        fileTypeAllowed,
        fileNumberAllowed,
        uploadFileHandler,
        removeFileHandler,
        isDisabled,
        isDeleteFileIconVisible,
        bgColor,
        flagShowJustIconBgColor,
        flagShowJustIcon,
        flagWhatsapp,
        flagLocallyStoreFile,
        flagRemoveFileConfirmationPopup
    } = props
    const fileList = Array.isArray(uploadedFileDetails) ? uploadedFileDetails : [];
    const [fileError, setFileError] = React.useState({ status: false, message: "" });
    const [showFileUploader, setShowFileUploader] = React.useState(true);
    const { vendorData } = useContext(UserContext) as UserContextPayload

    const { showError } = useGenericStore(useShallow((state) => ({
        showError: state.showError
    })))

    useEffect(() => {
        if (fileError.status && fileError.message) {
            showError(fileError.message)
        }
    }, [fileError]);

    useEffect(() => {
        if (fileList.length && fileList[0] !== "") {
            if (multipleFileAllow) {
                let countFileUpload = fileList.length
                if (countFileUpload == fileNumberAllowed) {
                    setShowFileUploader(false);
                } else {
                    setShowFileUploader(true);
                }
            } else {
                if (fileList.length) {
                    setShowFileUploader(false);
                } else {
                    setShowFileUploader(true)
                }
            }
        } else {
            setShowFileUploader(true);
        }
    }, [uploadFileHandler])

    const formatFileSize = (bytes: any, decimalPoint: any) => {
        if (bytes == 0) return '';
        var k = 1000,
            dm = decimalPoint || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    const removeFile = (data: any) => {
        removeFileHandler(data)
        //To upload to same file again after remove the uploaded file
        const inputEl = document.getElementById("image") as HTMLInputElement;
        if (inputEl) inputEl.value = "";
    }

    const RemoveConfirmation = (data: any) => {
        setFileError({
            status: false,
            message: ""
        })

        let flagFileRemovalApproval = false;
        
        if(flagRemoveFileConfirmationPopup){
            flagFileRemovalApproval = true;
        } else {
            const result = window.confirm("Are you sure you want to remove the file?");
            if (result) {
                flagFileRemovalApproval = true;
            } else {
                return;
            }
        }

        if(flagFileRemovalApproval){
            removeFile(data);
        }
    }

    const validationFile = async (event: any) => {
        try {
            if (!event.target.files || event.target.files.length === 0) return false;
            let filesEvent = Array.from(event.target.files);
            let findFilesFromParent = fileList[0] == "" ? [] : fileList
            if (!multipleFileAllow && (filesEvent && filesEvent.length > 1)) {
                setFileError({
                    status: true,
                    message: "Only a single file can be uploaded."
                });
                return false;
            } else if ((filesEvent.length > fileNumberAllowed) || (filesEvent.length + (findFilesFromParent.length || 0) > fileNumberAllowed)) {
                setFileError({
                    status: true,
                    message: `You can only upload up to ${fileNumberAllowed} file(s).`
                });
                return false;
            }

            if(fileSizeAllowed){
                // Check if any file exceeds the maximum allowed size
                const oversizedFile = filesEvent.find((file: any) => (file?.size / 1048576) > fileSizeAllowed);
                if (oversizedFile) {
                    setFileError({
                        status: true,
                        message: `Please upload a file smaller than ${fileSizeAllowed} MB`
                    });
                    return false;
                }
            }
            // Check if all files have the correct file type
            if (fileTypeAllowed) {
                const validFileTypes = fileTypeAllowed
                    .split(",")
                    .map((type: string) => type.trim().toLowerCase());
                const invalidFile = await Promise.all(
                    // @ts-ignore
                    filesEvent.map((file: File) => {
                        return new Promise((resolve) => {
                            const fileExtension = `.${file.name.split('.').pop()?.toLowerCase()}`;
                            const mimeType = file.type.toLowerCase();
                            const isExtensionAllowed = validFileTypes.includes(fileExtension);
                            const isMimeAllowed = validFileTypes.includes(mimeType);
                            if (!isExtensionAllowed && !isMimeAllowed) {
                                return resolve({
                                    status: true,
                                    message: `Invalid file type. Allowed types are: ${fileTypeAllowed}`
                                });
                            }
                            // === Check transparency ===
                            if (flagWhatsapp && (
                                (mimeType && mimeType.startsWith("image/")) ||
                                [".png", ".jpg", ".jpeg", ".gif", ".webp"].includes(fileExtension)
                            )) {
                                const reader = new FileReader();
                                reader.onload = function (event) {
                                    const img = new Image();
                                    img.onload = function () {
                                        const canvas = document.createElement("canvas");
                                        canvas.width = img.width;
                                        canvas.height = img.height;
                                        const ctx = canvas.getContext("2d");
                                        // @ts-ignore
                                        ctx.drawImage(img, 0, 0);
                                        // @ts-ignore
                                        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                                        const pixels = imageData.data;
                                        for (let i = 3; i < pixels.length; i += 4) {
                                            if (pixels[i] < 255) {
                                                // Transparency detected
                                                return resolve({
                                                    status: true,
                                                    message: `Image "${file.name}" has transparency, which is not allowed by whatsApp, please upload a non transparent image.`
                                                });
                                            }
                                        }
                                        // No error
                                        return resolve({ status: false });
                                    };
                                    img.onerror = () => resolve({
                                        status: true,
                                        message: `Failed to load image "${file.name}".`
                                    });
                                    img.src = event.target?.result as string;
                                };
                                reader.onerror = () => resolve({
                                    status: true,
                                    message: `Failed to read file "${file.name}".`
                                });
                                reader.readAsDataURL(file);
                            } else {
                                return resolve({
                                    status: false,
                                    message: 'message received'
                                });
                            }
                        });
                    })
                );
                // @ts-ignore
                const hasInvalid = invalidFile.find((f) => f.status);
                if (hasInvalid) {
                    setFileError({
                        status: true,
                        // @ts-ignore
                        message: hasInvalid.message
                    });
                    return false;
                }
            }
            setFileError({
                status: false,
                message: ""
            });
            return true;
        } catch (e) {
            console.log(e)
            setFileError({
                status: true,
                message: "Something went wrong."
            });
            return false;
        }
    }

    const uploadHandler = async (event: any) => {
        var checkFilevalidation = await validationFile(event)
        if (!checkFilevalidation) {
            return
        }
        if (!event.target.files.length) return;

        await props.uploadFileHandler(event);
        //To upload to same file again after remove the uploaded file
        event.target.value = null;
    }

    const shouldShowFileDownloadIcon = (fileArray: any) => {
        return flagLocallyStoreFile || fileArray.google_storage_id;
    }

    const downloadFileFromBlob = (fileUrl: string, fileName: string) => {
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    const handleFileDownload = (file: any) => {
        if(flagLocallyStoreFile && !file.google_storage_id){
            downloadFileFromBlob(file?.blobUrl, file?.name)
        } else {
            if (file.original_file_name || file.file_name) {
                if (file.google_storage_id) {
                    const url = getMediaUrl(vendorData, file.google_storage_id);
                    fetch(url)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.blob();
                    })
                    .then(blob => {
                        const fileToDownload = new File([blob], `${file.original_file_name || file?.file_name}`);
                        const url = URL.createObjectURL(fileToDownload);
                        downloadFileFromBlob(url, fileToDownload.name);
                        URL.revokeObjectURL(url);
                    })
                    .catch(error => {
                        console.error('There was a problem with the fetch operation:', error);
                    });
                }
            }
        }

    }

    const useStyles = makeStyles(() => ({
        customTooltip: {
            backgroundColor: redColor,
            color: whiteColor,
            fontSize: '13px',
            padding: '8px 15px',
            borderRadius: 5,
        },
        customArrow: {
            color: redColor,
        },
    }));
    const classes = useStyles();

    const getRedirectFileUrl = (fileArray: any) => {
        let redirectedUrl = "";
        
        if(flagLocallyStoreFile && !fileArray.google_storage_id){
            redirectedUrl = fileArray?.blobUrl;
        } else {
            redirectedUrl = getMediaUrl(vendorData, fileArray.google_storage_id);
        }
        
        return redirectedUrl;
    }

    return (
        <>
            <Grid container>
                <Grid item className="file-card" direction="column">
                    <>
                        <Grid container direction="column">
                            {/* @ts-ignore */}
                            {(showFileUploader[props?.fileDetails?.page_field_id] || !props?.fileDetails?.fileNewDesign) &&
                                <Grid item className={`${flagShowJustIcon ? 'justShowIcon-input' : 'file-inputs'}`} 
                                    sx={{ opacity: isDisabled ? "0.5" : "1", backgroundColor: flagShowJustIconBgColor || primaryColor }}
                                >
                                    <input
                                        id="image"
                                        accept={fileTypeAllowed}
                                        type="file"
                                        multiple
                                        className="file-inputs"
                                        disabled={!showFileUploader}
                                        style={{ display: isDisabled == true || isDisabled == "true" ? "none" : "" }}
                                        onChange={uploadHandler} >
                                    </input>
                                    <>

                                        {flagShowJustIcon ?
                                            <IconButton
                                                disableFocusRipple
                                                disableRipple
                                                disabled={isDisabled == true || isDisabled == "true"}
                                                className={styles.fileUploadIconBtn}
                                                sx={{ opacity: isDisabled == true || isDisabled == "true" ? "1" : "", cursor: isDisabled == true || isDisabled == "true" ? "default" : "pointer" }}
                                            >
                                                <FileUploadOutlined />
                                            </IconButton>
                                            :
                                            <button
                                                disabled={isDisabled == true || isDisabled == "true"}
                                                className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn} ${styles.uploadFileBtn}`}
                                                style={{ opacity: isDisabled == true || isDisabled == "true" ? "0.5" : "", cursor: isDisabled == true || isDisabled == "true" ? "unset" : "pointer", backgroundColor: bgColor ? bgColor : "" }} >
                                                <Grid container justifyContent={"center"} alignItems="center">
                                                    <Grid item className={styles.uploadFileIconGrid}>
                                                        <IconsColor iconName='uploadToGoogleStorage' width="35px" height="25px" fillColor={blackColor} />
                                                    </Grid>
                                                    <Grid item>
                                                        <Grid container direction="column" justifyContent="center" alignItems="start">
                                                            <div className={globalStyles.displayFlexStyle}>
                                                                <span className={`${globalStyles.displayFlexStyle} ${globalStyles.tertiaryFontSize} ${globalStyles.tertiaryFontWeight} ${globalStyles.blackColor}`}>Drag & Drop files here, or {" "}</span><span className={`${globalStyles.displayFlexStyle} ${globalStyles.tertiaryFontSize} ${globalStyles.tertiaryFontWeight} ${globalStyles.primaryColor} ${styles.browseFiletext}`}>Browse</span>
                                                            </div>
                                                            {fileSizeAllowed && 
                                                                <Grid item className={globalStyles.displayFlexStyle}>
                                                                    <span className={`${globalStyles.tertiaryFontSize} ${globalStyles.tertiaryFontWeight} ${styles.fileSizeLimitText}`}>
                                                                        {fileSizeAllowed} MB limit for single file
                                                                    </span>
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </button>
                                        }
                                    </>
                                </Grid>
                            }

                            <>
                                {!flagShowJustIcon &&
                                    <>
                                        {fileList.length > 0 && fileList[0] !== "" && fileList.map((fileArray: any, ind: number) => {

                                            var roundedNumber = formatFileSize(fileArray?.size ? fileArray?.size : 0, "")
                                            return <React.Fragment key={ind}>
                                                {<Grid item className={styles.viewUploadedFileGrid}
                                                // className={!fileArray.google_storage_id ? "file_item" : "file_item_after_uploaded"}
                                                >
                                                    <Grid container sx={{ backgroundColor: bgColor ? bgColor : "" }} className={`${globalStyles.fullwidth} ${fileArray.previewImageSrc ? "fileUploadedGrid" : "file_background_design"}`}>
                                                        <Grid item direction="column" className={globalStyles.fullwidth}>
                                                            <Grid container alignItems="center" className={"delete_container"}>
                                                                <a rel="noreferrer" href={getRedirectFileUrl(fileArray)} download={fileArray.name} target="_blank" className={styles.uploadedFileAnchorTag}>
                                                                    <Grid item xs={11} className={`"file_name" ${globalStyles.fullwidth}`} >
                                                                        <div className={`${globalStyles.displayFlex} ${globalStyles.fullwidth} ${styles.uploadedFileAnchorDiv}`}>
                                                                            <div className={`${globalStyles.displayFlex} ${styles.uploadedFileAnchorDiv}`}>
                                                                                {fileArray.previewImageSrc &&
                                                                                    <img className={`"file_type_uploaded" ${styles.uploadedFilePreviewImg}`} src={fileArray.previewImageSrc} alt="file" />
                                                                                }
                                                                                <span className={`"file_name_txt" ${styles.uploadedFileNameText} ${globalStyles.tertiaryFontSize}`}>{fileArray.name || fileArray}  </span>
                                                                            </div>
                                                                            {roundedNumber !== '' &&
                                                                                <>
                                                                                    &nbsp;
                                                                                    &nbsp;
                                                                                    <div>
                                                                                        <span className="file_size"> {roundedNumber}</span>
                                                                                    </div>
                                                                                </>
                                                                            }

                                                                        </div>
                                                                    </Grid>
                                                                </a>
                                                                {(isDisabled != true) &&
                                                                    <>
                                                                        <Grid item xs={(isDeleteFileIconVisible != undefined && !isDeleteFileIconVisible) ? 1 : 0.5}>
                                                                            <Grid container gap="10px" flexWrap={"nowrap"} justifyContent={"end"}>
                                                                                {shouldShowFileDownloadIcon(fileArray) &&
                                                                                    <Grid item className={`${globalStyles.clickable} ${globalStyles.zIndex1} delete_icon`} onClick={() => { handleFileDownload(fileArray) }}>
                                                                                        <IconsColor iconName="download" width="25px" height="25px" fillColor={blackColor} />
                                                                                    </Grid>}

                                                                                {isDeleteFileIconVisible != undefined ?
                                                                                    !isDeleteFileIconVisible &&
                                                                                    <Grid item className={`${globalStyles.clickable} ${globalStyles.zIndex1} delete_icon`}>
                                                                                        <DeleteIcon className="delete_onclick" onClick={() => {
                                                                                            RemoveConfirmation(fileArray.google_storage_id ? fileArray.google_storage_id : fileArray)
                                                                                        }} />
                                                                                    </Grid>
                                                                                    :
                                                                                    <Grid item className={`${globalStyles.clickable} ${globalStyles.zIndex1} delete_icon`}>
                                                                                        <DeleteIcon className="delete_onclick" onClick={() => {
                                                                                            RemoveConfirmation(fileArray.google_storage_id ? fileArray.google_storage_id : fileArray)
                                                                                        }} />
                                                                                    </Grid>
                                                                                }
                                                                            </Grid>
                                                                        </Grid>
                                                                    </>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>}
                                            </React.Fragment>
                                            // }
                                        })}
                                    </>
                                }
                            </>
                            {fileError.status == true ?
                                flagShowJustIcon ?
                                    <Grid item className={styles.fileErrorGridForIcon}>
                                        <Tooltip title={fileError.message} placement='bottom' arrow
                                            classes={{ tooltip: classes.customTooltip, arrow: classes.customArrow }}
                                        >
                                            <div className={styles.fileErrorDivForIcon}>
                                                <IconsColor fillColor={redColor} iconName="info" height={"18"} width={"18"} />
                                            </div>
                                        </Tooltip>
                                    </Grid>
                                    :
                                    <Grid item className={`${globalStyles.secondaryFontSize} ${styles.fileErrorMessageGrid}`}>
                                        {fileError.message}
                                    </Grid>
                                : ""}
                        </Grid>
                    </>
                </Grid>
            </Grid>
        </>
    )
}

export default FileUpload;